import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { PaymentTransaction } from 'src/app/models/payment-transaction';
import { VposBatchAppView } from 'src/app/models/vpos-batch-app-view';
import { TransactionSummaryDetailModel } from 'src/app/models/transaction-summary-detail-model';
import { catchError, map } from 'rxjs';


@Injectable()
export class BatchService {
  userId: any;
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {

    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }
  BatchClose(MerchantKeyId) {
    return this.service.create(environment.BatchCloseUrl + "?MerchantKeyId=" + MerchantKeyId, MerchantKeyId);
  }
  GetBatches(MerchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();

    return this.http.get<VposBatchAppView>(environment.GetBatchesUrl + "?MerchantKeyId=" + MerchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetBatchDetail(batchid, MerchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<VposBatchAppView>(environment.GetBatchDetailUrl + "?MerchantKeyId=" + MerchantKeyId + "&batchid=" + batchid + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetMerchantServicesAndFees(merchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentTransaction>(environment.getmerchantServiceAndFeesListUrl + "?merchantkeyId=" + merchantKeyId+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers });
  }

  GetSettledTransactions(batchid, MerchantKeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<PaymentTransaction>(environment.GetSettledTransactionUrl + "?MerchantKeyId=" + MerchantKeyId + "&batchid=" + batchid+ "&LoginUserId="+merchantdata.UserId
    , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }

  GetTransactionSummaryDetails(merchantKeyId, transactionId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<TransactionSummaryDetailModel>(environment.getTransactionSummaryDetailsUrl + "?merchantKeyId=" + merchantKeyId
      + "&transactionid=" + transactionId
      + "&transactionid=" + transactionId+ "&LoginUserId="+merchantdata.UserId, { headers: this.headers });
  }

  GetBatchesUrl(merchantkeyId) {
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetBatchesUrl + "?MerchantKeyId=" + merchantkeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }
  batchesFilterdataurl(data) {
  
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<any>(environment.batchesFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&transactionStatus=" + transactionStatus
    //   + "&PaymentType=" + PaymentType + "&batchid=" + batchid + "&Amount=" + Amount + "&AmountCheck=" + amountcompare + "&LoginUserId=" + merchantdata.UserId
    //   , { headers: this.headers });
      return this.http.post<any>(environment.batchesFilterdataurl,data,{headers:this.headers})
  }
  GetHeaderdetails()
  {
    let loggedUsername =this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token =environment.GetAuthenticationToken + ":" +this.common.GetAuthToken()+ ":" + "IT"+ ":"+environment.GetAuthencticationKey+":"+this.common.getSid()+":"+merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
    set('Authorization', 'basic ' + btoa(this.token));
 
 
  }
  GetMerchantBatchesfilter(data) {
    this.GetHeaderdetails();

      return this.http.post<any>(environment.GetMerchantBatchesfilter,data,{headers:this.headers})
  }
}
